import { render, staticRenderFns } from "./MedicalDevices.vue?vue&type=template&id=d9705d3e"
import script from "./MedicalDevices.vue?vue&type=script&lang=js"
export * from "./MedicalDevices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports